import React from "react";
import CreateOrUpdateAdminUserForm from "../Forms/CreateOrUpdateAdminUserForm";
import Modal from "reactstrap/lib/Modal";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ModalBody from "reactstrap/lib/ModalBody";

class CreateOrUpdateUserModal extends React.Component {
  render() {
    return (
      <Modal size="md" isOpen={this.props.show} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>
          {this.props.user ? "Uppdatera användare" : "Lägg till användare"}
        </ModalHeader>
        <ModalBody>
          <CreateOrUpdateAdminUserForm
            user={this.props.user}
            updateUsers={this.props.updateUsers}
            dismissModal={this.props.toggle}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default CreateOrUpdateUserModal;
